<div class="bg-white background"></div>
<app-menu-template2>
  <main class="container-fluid">
    <header class="pt-3">
      <h1>¿Como podemos ayudarte?</h1>
      <p>A continuación puede encontrar una serie de videos que le brindan ayuda para conocer como desarrollar
        diferentes actividades relacionadas con el uso del Registro Nacional de Turismo.</p>
    </header>
    <article class="row">
      <section class="col-8 mb-3 mt-2">
        <video *ngIf="selectData.ruta_url; else novideo" width="100%" height="auto" controls autoplay #videoPlay>
          <source src={{selectData.ruta_url}} type="video/mp4">
          Tu navegador no soporta la visualización del vídeo
        </video>
        <ng-template #novideo>
          <div class="bg-body w-100 h-auto"></div>
        </ng-template>
        <h3 class="mt-3" [innerHTML]="selectData.titulo"></h3>
        <!--Video consultado-->
      </section>
      <aside class="col-4 search-video">
        <form [formGroup]="formSearch">
          <input id="search" class="form-control mt-2 mb-2" type="text" placeholder="Buscar" formControlName="search">
        </form>
        <!--Videos-->
        <div *ngFor="let tutorial of tutoriales | filterBy: {titulo: formSearch.value.search}; let i=index;" class="d-flex mb-3">
          <video width="200" height="115" preload="metadata" (click)="selectRow(tutorial)" class="pointer">
            <source [src]="tutorial.ruta_url + '#t=51' " type="video/mp4">
            Tu navegador no soporta la visualización del vídeo
          </video>
          <p class="pl-3 d-flex flex-column justify-content-center pointer" (click)="selectRow(tutorial)" [innerHTML]="tutorial.titulo"></p>
        </div>
      </aside>
    </article>
  </main>
</app-menu-template2>